import { darken } from "polished";
import styled from "styled-components";
import "../../styles/sass/Pages/_newDesign.scss";

export const Container = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	align-items: center;
	justify-content: center;
	overflow-y: auto;

	@media only screen and (max-device-width: 900px) {
		flex-direction: column;
		height: 60%;
	}
`;

export const Content = styled.section`
	width: 50%;
	height: 100%;
	background: #23242f;
	z-index: 1000;
	padding: 1rem 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	font-family: "MetropolisRegular";

	@media only screen and (max-device-width: 900px) {
		background: #13141b;
		position: relative;
		width: 23rem;
		justify-content: flex-start;
		padding: 0;
		height: 90%;
	}
`;

export const Wrapper = styled.div`
	width: 27rem;
	display: flex;
	flex-direction: column;
	justify-content: space-evenly;

	@media only screen and (max-device-width: 900px) {
		width: 21.5rem;
		justify-content: space-between;
	}
`;

export const Title = styled.span`
	color: #ffffff;
	font-size: 24px;
	font-family: var(--font-family-metropolis-semi-bold);
	width: 100%;
	padding-bottom: 0.5rem;
`;

export const Subtitle = styled.span`
	font-size: 16px;
	color: #ffffff;
	font-family: "MetropolisRegular";

	@media only screen and (max-device-width: 900px) {
		display: none;
	}
`;

export const SubtitleMobile = styled.span`
	font-size: 16px;
	color: #ffffff;
	font-family: "MetropolisRegular";
	display: none;

	@media only screen and (max-device-width: 900px) {
		display: contents;
	}
`;

export const ContainerButton = styled.div`
	width: 27rem;
	height: 6rem;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	margin-top: 2.5rem;

	@media only screen and (max-device-width: 900px) {
		width: 21.5rem;
	}

	@media only screen and (max-device-width: 380) {
		width: 20.5rem;
	}
`;

export const SubmitButtom = styled.button`
	color: #13141b;
	width: 100%;
	background-color: #01e59b;
	border-radius: 8px;
	align-self: center;
	padding: 5px;
	border: 0px;
	font-size: 16px;
	height: 40px;
	font-family: var(--font-family-metropolis-semi-bold);
	outline: none !important;

	&:hover {
		background: ${darken(0.03, "#01E59B")};
	}

	&:disabled {
		opacity: 0.24;
	}
`;

export const ButtonOpenAccount = styled.button`
	width: 100%;
	display: flex;
	justify-content: center;
	background: transparent;
	color: #01e59b;
	text-decoration: none;
	font-size: 16px;
	height: 40px;
	border: 2px solid #01e59b;
	border-radius: 8px;
	align-items: center;
	font-family: var(--font-family-metropolis-semi-bold);
	outline: none !important;

	&:hover {
		color: #01e59b;
		text-decoration: underline;
	}
`;
